export default __webpack_public_path__ + "static/media/graf01.2e3e3e4e.png";